import React, { useEffect, useRef, useState } from 'react'
import './rewards.styles.scss'

import { useSelector } from 'react-redux';
import ViewRewardsModal from './view-rewards-modal.component';
import { switchPlayerMenu } from '../side-menu.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import RewardItemUnclicked from './reward-item-unclicked.component';
import RewardItemClicked from './reward-item-clicked.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faBoxOpen, faGem, faGift, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { UseCloudGameplay } from '@/utils/firebase.utils';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

const PlayerRewards = ({ 
    gameData, 
    playerData, 
    playerActivity, 
    gameElements 
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ rewardModalIsOpen, setRewardModalIsOpen ] = useState(false);
    const [ modalActivity, setModalActivity ] = useState(null);
    const [ activityToDisplay, setActivityToDisplay ] = useState(null);
    const [ modalHeadText, setModalHeadText ] = useState(null);
    const [ notificationCounts, setNotificationCounts ] = useState(null);
    const [ rewardsToOpen, setRewardsToOpen ] = useState(null);
    const [ viewCategory, setViewCategory ] = useState('reward');
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const [ alertMessage, setAlertMessage ] = useState(false);
    const [ clearLoading, setClearLoading ] = useState(false);
    const rewardRef = useRef();
    const approveRef = useRef();

    useEffect(() => {
        if (!playerActivity || !playerData || !viewCategory) {return;}
        let newActivityObj = {};
        const content = Object.values(playerActivity)
        .filter(a => a.display === viewCategory);
        for (let a of content) {
            newActivityObj[a.id] = a;
        }
        setActivityToDisplay(newActivityObj)
    }, [ playerActivity, playerData, viewCategory ])

    useEffect(() => {
        if (!playerActivity || !playerData || !playerData.newStuff) return;
        rewardRef.current = [];
        let countObj = {
            'reward': 0,
            'achievement': 0,
            'prizepack': 0,
            'purchase': 0
        }
        for (let a of playerData.newStuff) {
            if (playerActivity[a]) {
                countObj[playerActivity[a].display]++
                rewardRef.current.push(a);
            }
        }
        setRewardsToOpen([...rewardRef.current]);
        setNotificationCounts(countObj);
    }, [playerActivity || playerData])

    useEffect(() => {
        const pageTitle = document.getElementById('page-title');
        if (pageTitle) {
            pageTitle.innerText = 'My Rewards'
        }
        switchPlayerMenu('rewards-btn');
    }, []);


    function handleRewardModalOpen(activityId) {
        const act = playerActivity[activityId];
        setModalActivity(act)
        setModalHeadText(
            act.display === 'prizepack'
            ? 'New '+ act.title + '!'
            : 'Your New Rewards!'
        )
        setRewardModalIsOpen(true)
    }

    function handleRewardModalClose() {
        setRewardModalIsOpen(false)
    }

    async function clearNewRewards() {
        setConfirmMessage('Are you sure you want to open all of the unopened rewards?');
        approveRef.current = () => {
            continueClear();
        }

        async function continueClear() {
            setClearLoading(true);
            const rewardsToClear = [...rewardsToOpen];
            console.log(rewardsToClear);
            const res = await UseCloudGameplay(
                'markRewardAsViewed',
                {
                    'gameId': gameData.gameId,
                    'playerId': playerData.playerId,
                    'rewardIdArr': rewardsToClear,
                }
            )
            console.log(res);
            setClearLoading(false);
            if (res.error) {
                setAlertMessage(`Something went wrong. Try again later. (Error: ${res.error})`);
                return;
            }
            rewardRef.current = [];
            setRewardsToOpen(rewardRef.current);
        }
    }
    

    return (
        <div className='player-rewards g-card'>
            <div className='player-title'>
                <ImageContainer src='/images/icons/treasure.png' alt='rewards icon' className='player-title-icon' />
                My Rewards
            </div>
            <hr />
            <div className={`reward-grid ${screenSize}`}>
                <div className='left-menu'>
                    <button 
                        className={`g-button med-btn reward-button ${viewCategory === 'reward' ? 'primary' : ''}`}
                        onClick={() => setViewCategory('reward')}>
                        <div className='notification-with-badge'>
                            <FontAwesomeIcon icon={faGem} />
                            {
                                (
                                    screenSize !== 'mobile' 
                                ) &&
                                'Rewards'
                            }
                            {
                                (notificationCounts && notificationCounts.reward > 0) &&
                                <span className="badge">{notificationCounts.reward}</span>
                            }
                        </div>
                    </button>
                    <button 
                        className={`g-button med-btn reward-button ${viewCategory === 'achievement' ? 'primary' : ''}`}
                        onClick={() => setViewCategory('achievement')} >
                        <div className='notification-with-badge'>
                            <FontAwesomeIcon icon={faAward} />
                            {
                                (
                                    screenSize !== 'mobile' 
                                ) &&
                                'Achievements'
                            }
                            {
                                (notificationCounts && notificationCounts.achievement > 0) &&
                                <span className="badge">{notificationCounts.achievement}</span>
                            }
                        </div>
                    </button>
                    {
                        (
                            gameData && 
                            gameData.access.includes('prizepacks') &&
                            gameElements &&
                            Object.values(gameElements).filter(e => 
                                e.status === 'active' &&
                                e.opt_itemType === 'prizepack'
                            ).length > 0
                        ) &&
                        <button 
                            className={`g-button med-btn reward-button ${viewCategory === 'prizepack' ? 'primary' : ''}`}
                            onClick={() => setViewCategory('prizepack')} >
                            <div className='notification-with-badge'>
                                <FontAwesomeIcon icon={faGift} />
                                {
                                (
                                    screenSize !== 'mobile' 
                                ) &&
                                'Prize Packs'
                            }
                                {
                                    (notificationCounts && notificationCounts.prizepack > 0) &&
                                    <span className="badge">{notificationCounts.prizepack}</span>
                                }
                            </div>
                        </button>
                    }
                    {
                        (gameData.access.includes('marketplace')) &&
                        <button 
                            className={`g-button med-btn reward-button ${viewCategory === 'purchase' ? 'primary' : ''}`}
                            onClick={() => setViewCategory('purchase')} >
                            <div className='notification-with-badge'>
                                <FontAwesomeIcon icon={faShoppingCart} />
                                {
                                (
                                    screenSize !== 'mobile' 
                                ) &&
                                'My Purchases'
                            }
                                {/* {
                                    (notificationCounts && notificationCounts.prizepack > 0) &&
                                    <span className="badge">{notificationCounts.prizepack}</span>
                                } */}
                            </div>
                        </button>
                    }
                    {
                        (rewardsToOpen && rewardsToOpen.length > 0) &&
                        (
                            (clearLoading) 
                            ?
                            <button className='g-button small-btn'>
                                <ThreeDotsLoader />
                            </button>
                            :
                            <button 
                                className='g-button small-btn open-all-button'
                                onClick={() => clearNewRewards()} >
                                <FontAwesomeIcon icon={faBoxOpen} />
                                {
                                    (
                                        screenSize !== 'mobile' 
                                    ) &&
                                    <div className='meta '>Open All Rewards</div>
                                }
                            </button>
                        )
                    }
                </div>
                
                <div className='right-col'>
                    {
                        (
                            screenSize === 'mobile' ||
                            screenSize === 'tablet'
                        ) &&
                        <div className='rewards-mobile-head'>
                            <h2>
                            {
                                viewCategory === 'reward' &&
                                'Rewards'
                            }
                            {
                                viewCategory === 'achievement' &&
                                'Achievements'
                            }
                            {
                                viewCategory === 'prizepack' &&
                                'Prize Packs'
                            }
                            {
                                viewCategory === 'purchase' &&
                                'Purchases'
                            }
                            </h2>
                            <hr />
                        </div>
                    }
                    <div className={`reward-list-grid ${screenSize}`}>
                    {
                        (activityToDisplay && playerData) &&
                        Object.values(activityToDisplay)
                        .sort((a,b) => a.ts < b.ts ? 1 : -1)
                        .map(act => (
                            (
                                playerData.newStuff && 
                                playerData.newStuff.includes(act.id) &&
                                act.display !== 'purchase'
                            )
                            ?
                            <div key={act.ts} >
                                <RewardItemUnclicked 
                                    reward={act}
                                    gameData={gameData}
                                    playerData={playerData}
                                    handleRewardModalOpen={handleRewardModalOpen} />
                            </div>
                            :
                            <div key={act.ts}>
                                <RewardItemClicked 
                                    reward={act}
                                    handleRewardModalOpen={handleRewardModalOpen} />
                            </div>
                        ))
                    }
                    </div>
                </div>
            </div>
            <ViewRewardsModal 
                playerData={playerData}
                isOpen={rewardModalIsOpen} 
                onClose={() => handleRewardModalClose()} 
                activity={modalActivity} 
                width={'normal'} 
                closeButton={true}
                modalHeadText={modalHeadText} />
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default PlayerRewards